import { COLOR } from '../../data/colors.data'

export enum PATIENT_ACCOUNT_CLEARANCE_STATUS {
  NONE = 'N',
  APPROVED = 'A',
  DENIED = 'D',
  REQUIRED = 'R',
  NOT_REQUIRED = 'NR',
  PENDING = 'P',
  MISSING_PROCEDURE_CODES = 'NO-CPT',
  MISSING_COVERAGE = 'NO-INS',
}

export const patientAccountClearanceStatusColorMap = {
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.NONE]: COLOR.DEFAULT,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.APPROVED]: COLOR.GREEN,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.DENIED]: COLOR.RED,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.MISSING_PROCEDURE_CODES]: COLOR.RED,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.MISSING_COVERAGE]: COLOR.RED,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.REQUIRED]: COLOR.YELLOW,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.NOT_REQUIRED]: COLOR.GREEN,
  [PATIENT_ACCOUNT_CLEARANCE_STATUS.PENDING]: COLOR.YELLOW,
}

export enum PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS {
  APPROVED = 'A',
  DENIED = 'D',
  REQUIRED = 'R',
  NOT_REQUIRED = 'NR',
  PENDING = 'P',
  ON_AUTH_NOT_SCHEDULED = 'E',
}

/** Statuses ordered by how much authorization work they still need, most first. */
export const patientAccountProcedureClearanceStatusPriority: PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS[] = [
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.REQUIRED,
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.PENDING,
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.DENIED,
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.ON_AUTH_NOT_SCHEDULED,
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.APPROVED,
  PATIENT_ACCOUNT_PROCEDURE_CLEARANCE_STATUS.NOT_REQUIRED,
]
